import React from "react";
import { Navigate, useParams, useLocation } from "react-router-dom";

const RedirectToEmbed = () => {
  const { workspace_id, page_id, group_id } = useParams();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  if (group_id) {
    searchParams.set("group", group_id);
  }
  if (page_id) {
    searchParams.set("page", page_id);
  }

  const queryString = searchParams.toString();

  return (
    <Navigate
      to={`/workspace/${workspace_id}/embed${queryString ? `?${queryString}` : ""}`}
      replace
    />
  );
};

export default RedirectToEmbed;
